import { IAdvancedFormConfig } from '~shared/modules/advanced-form/models/advanced-form.model';
import {
  BASE_ADDRESS_ADVANCED_FORM_CONFIG,
  BASE_ADDRESS_FIELD_LIST,
} from '~shared/modules/addresses/constants/base-address.constant';

export const ADVANCED_FORM_CONFIG: IAdvancedFormConfig = {
  ...BASE_ADDRESS_ADVANCED_FORM_CONFIG,
  formSectionList: [
    {
      fieldList: [
        {
          name: 'companyName',
          label: 'SHARED.ADDRESS.COMPANY_NAME.LABEL',
        },
        ...BASE_ADDRESS_FIELD_LIST,
      ],
    },
  ],
  actionList: [],
};
